import React, { Component } from 'react';
import { FlatButton, List, ListItem, Popover } from 'material-ui';
import moment from 'moment';
import PropTypes from 'prop-types';

import ArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

const { array, bool, func, object } = PropTypes;

class DateRange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCustomDate: false,
    };
  }

  getRangeDates = (timeValue, timeVar, format) => ({
    startDate: moment().clone().utc().add(timeVar, timeValue).startOf(timeValue === 'week' ? 'isoWeek' : timeValue).format(format || ''),
    endDate: moment().clone().utc().add(timeVar, timeValue).endOf(timeValue === 'week' ? 'isoWeek' : timeValue).format(format || ''),
  });

  getDateRange = (timeValue, timeVar) => {
    const { startDate, endDate } = this.getRangeDates(timeValue, timeVar, 'D MMM');
    return `${startDate} - ${endDate}`;
  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
    this.props.onButtonClick();
  };

  handleItemClick = (index) => {
    console.log('click', index);
    console.log('selectedDate', this.getRangeDates(this.props.dateChoices[index].timeValue, this.props.dateChoices[index].timeVar));

    
    this.setState({ isCustomDate: index === -1 });
  }

  handleRequestClose = () => {
    this.props.onButtonClick();
  };

  render() {
    const { dateChoices, isCustomRange, isDatePickerOpen, onButtonClick } = this.props;

    return (
      <div>

        { !this.state.isCustomDate ? <FlatButton
          backgroundColor="rgba(0,0,0,0.04)"
          icon={<ArrowDownIcon />}
          label="Select a date range"
          labelPosition="after"
          onClick={this.handleClick}
        >
        <Popover
          open={isDatePickerOpen}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={this.handleRequestClose}
        >
        <List>
          {dateChoices.map((options, i) =>
            <ListItem key={i} primaryText={
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ paddingRight: '50px' }}>
                  {options.title}
                </span>
                <span style={{ fontSize: '14px', fontWeight: 600 }}>
                  {this.getDateRange(options.timeValue, options.timeVar)}
                </span>
              </div>} onClick={() => this.handleItemClick(i)}
            />
          )}
          <ListItem onClick={() => this.handleItemClick(-1)} primaryText="Custom Range..." />
        </List>
      </Popover>
    </FlatButton> :
      <div>
        <FlatButton
          backgroundColor="rgba(0,0,0,0.04)"
          icon={<ArrowDownIcon />}
          label="Select a date range"
          labelPosition="after"
          onClick={this.handleClick}
        />
      </div>
      }
      </div>
    );
  }
}

DateRange.propTypes = {
  dateChoices: array,
  isCustomRange: bool,
  isDatePickerOpen: bool,
  onButtonClick: func,
  style: object,
};

export default DateRange;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/dashboardFilter/dateRange.jsx